import formsState from "./forms-state.json";

const { jsonSchema, uiSchema: rootUiSchema, definitions } = formsState.jsonFormsEdit;

/** Schema from forms-state.json (root form + definitions for $ref). */
export const schema = {
  ...jsonSchema,
  ...(definitions && { definitions }),
};

/** Root uiSchema from forms-state.json. */
export const uiSchema = rootUiSchema;

/** Initial form data (empty object). */
export const initialData: Record<string, unknown> = {};
